// import react libraries
import { useEffect, useState } from "react";
import axios from "axios";
// import files
import { env } from "../../env";

const SLIDE_DURATION = 4000;

const AnniversaryBanner = () => {
    const [slides, setSlides] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const clientToken = localStorage.getItem('clientToken');
        if (!clientToken) return;

        axios.post(`${env.REACT_APP_RPC_URL}/rpc/get_banner_list`, {
            p_company_id: env.REACT_APP_COMPANY_ID
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${clientToken}`
            }
        }).then((response) => {
            const dynamicSlides = [...(response.data || [])]
                .sort((a, b) => a.display_order - b.display_order)
                .map((banner) => ({ src: banner.image_url, alt: banner.banner_name }));
            setActiveIndex(0);
            setSlides(dynamicSlides);
        }).catch((error) => {
            if (error.response?.data?.code === "PGRST301") {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                localStorage.removeItem("clientToken");
                window.location.reload();
                return;
            }
            // clientToken is a separate RPC credential from the main session token
            // (see getMonthlyInvoiceData in Dashboard.js) — any other failure here just
            // means the dynamic banners couldn't load, not that the session is invalid.
            console.log(error);
        });
    }, []);

    useEffect(() => {
        if (slides.length <= 1) return;
        const timer = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % slides.length);
        }, SLIDE_DURATION);
        return () => clearInterval(timer);
    }, [slides]);

    if (slides.length === 0) return null;

    const activeSlide = slides[activeIndex];

    return (
        <div className="w-full p-1">
            {/* shows the banner image exactly as received from the backend —
                full width, natural height, no cropping, stretching, or letterboxing */}
            <img
                src={activeSlide.src}
                alt={activeSlide.alt}
                className="w-full h-auto rounded-xl"
            />
            {slides.length > 1 &&
                <div className="flex justify-center items-center space-x-1.5 pt-2">
                    {slides.map((slide, index) => (
                        <button
                            key={slide.alt}
                            onClick={() => setActiveIndex(index)}
                            aria-label={`slide ${index + 1}`}
                            className={(index === activeIndex ? "bg-blue-normal w-4" : "bg-gray-dark1 w-1.5") + " h-1.5 rounded-full transition-all duration-300"}
                        />
                    ))}
                </div>
            }
        </div>
    );
};

export default AnniversaryBanner;
